export default "__VITE_ASSET__7bf16aa6__"